"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nText = void 0;
const i18nResourceLocal_1 = require("./i18nResourceLocal");
class I18nText {
    constructor(locale, externalMessages) {
        this.messages = (0, i18nResourceLocal_1.getTextResources)(locale);
        if (externalMessages) {
            for (const key in externalMessages) {
                this.messages[key] = externalMessages[key];
            }
        }
        this.locale = locale;
    }
    get(id) {
        let t;
        if (id !== undefined) {
            t = this.messages[id];
        }
        return t !== undefined ? t : id;
    }
    getLocale() {
        return this.locale;
    }
}
exports.I18nText = I18nText;
